import React, { useEffect } from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
import { motion } from 'framer-motion';
import { Clock, Calendar, Users, Shield } from 'lucide-react';
export function SchedulePage() {
  useEffect(() => {
    document.title = "Class Schedule | Walker's Martial Arts | Bloomington, Illinois";
  }, []);
  const schedule = {
    monday: {
      privateLessons: '5:00 AM - 9:00 PM',
      taekwondo: [{
        name: 'Little Tigers',
        time: '4:30 PM - 5:15 PM',
        ages: 'Ages 3-5'
      }, {
        name: 'Individual & Family Class',
        time: '6:00 PM - 7:00 PM',
        ages: 'All Ages'
      }, {
        name: 'Individual & Family Class',
        time: '7:00 PM - 8:00 PM',
        ages: 'All Ages'
      }],
      kickboxing: [{
        name: 'Kickboxing',
        time: '5:15 PM - 6:00 PM',
        ages: 'Ages 6-11 & under'
      }, {
        name: 'Kickboxing',
        time: '7:15 PM - 8:00 PM',
        ages: 'Ages 12 & up'
      }]
    },
    tuesday: {
      privateLessons: '5:00 AM - 9:00 PM',
      taekwondo: [{
        name: 'Little Tigers',
        time: '4:30 PM - 5:15 PM',
        ages: 'Ages 3-5'
      }, {
        name: 'Individual & Family Class',
        time: '6:00 PM - 7:00 PM',
        ages: 'All Ages'
      }, {
        name: 'Individual & Family Class',
        time: '7:00 PM - 8:00 PM',
        ages: 'All Ages'
      }]
    },
    wednesday: {
      privateLessons: '5:00 AM - 9:00 PM',
      taekwondo: [{
        name: 'Little Tigers',
        time: '4:30 PM - 5:15 PM',
        ages: 'Ages 3-5'
      }, {
        name: 'Individual & Family Class',
        time: '6:00 PM - 7:00 PM',
        ages: 'All Ages'
      }, {
        name: 'Individual & Family Class',
        time: '7:00 PM - 8:00 PM',
        ages: 'All Ages'
      }],
      kickboxing: [{
        name: 'Kickboxing',
        time: '5:15 PM - 6:00 PM',
        ages: 'Ages 6-11 & under'
      }, {
        name: 'Kickboxing',
        time: '7:15 PM - 8:00 PM',
        ages: 'Ages 12 & up'
      }]
    },
    thursday: {
      privateLessons: '5:00 AM - 9:00 PM',
      taekwondo: [{
        name: 'Little Tigers',
        time: '4:30 PM - 5:15 PM',
        ages: 'Ages 3-5'
      }, {
        name: 'Individual & Family Class',
        time: '6:00 PM - 7:00 PM',
        ages: 'All Ages'
      }, {
        name: 'Individual & Family Class',
        time: '7:00 PM - 8:00 PM',
        ages: 'All Ages'
      }]
    },
    friday: {
      privateLessons: '5:00 AM - 9:00 PM',
      sparring: [{
        name: 'Sparring',
        time: '6:00 PM - 7:00 PM',
        ages: 'All Ages'
      }]
    },
    saturday: {
      privateLessons: '5:00 AM - 12:00 PM',
      note: 'Private lessons only - No group classes'
    },
    sunday: {
      privateLessons: '5:00 AM - 12:00 PM',
      note: 'Private lessons only - No group classes'
    }
  };
  const days = [{
    key: 'monday',
    label: 'Monday'
  }, {
    key: 'tuesday',
    label: 'Tuesday'
  }, {
    key: 'wednesday',
    label: 'Wednesday'
  }, {
    key: 'thursday',
    label: 'Thursday'
  }, {
    key: 'friday',
    label: 'Friday'
  }, {
    key: 'saturday',
    label: 'Saturday'
  }, {
    key: 'sunday',
    label: 'Sunday'
  }];
  return <div className="bg-black min-h-screen" data-id="element-898">
      <Navigation data-id="element-899" />

      {/* Page Header */}
      <div className="pt-32 pb-12 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-900">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} data-id="element-901">
          <h1 className="text-4xl md:text-6xl font-extrabold text-white mb-6" data-id="element-902">
            Class <span className="text-[#00D4FF]" data-id="element-903">Schedule</span>
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl leading-relaxed" data-id="element-904">
            Find the perfect class time for your schedule. We offer flexible
            hours throughout the week to accommodate busy families.
          </p>
        </motion.div>
      </div>

      {/* Schedule Grid */}
      <section className="py-12 bg-[#0a0a0a]" data-id="element-905">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-906">
          <div className="space-y-8" data-id="element-907">
            {days.map((day, index) => {
            const daySchedule = schedule[day.key as keyof typeof schedule];
            return <motion.div key={day.key} initial={{
              opacity: 0,
              y: 20
            }} whileInView={{
              opacity: 1,
              y: 0
            }} viewport={{
              once: true
            }} transition={{
              delay: index * 0.05
            }} className="bg-[#1a1a1a] rounded-2xl border border-gray-800 overflow-hidden" data-id="element-908">
                  {/* Day Header */}
                  <div className="bg-gradient-to-r from-[#00D4FF]/20 to-transparent p-6 border-b border-gray-800" data-id="element-909">
                    <div className="flex items-center justify-between" data-id="element-910">
                      <h2 className="text-3xl font-bold text-white uppercase tracking-wide" data-id="element-911">
                        {day.label}
                      </h2>
                      <div className="flex items-center gap-2 text-[#00D4FF]" data-id="element-912">
                        <Clock className="w-5 h-5" data-id="element-913" />
                        <span className="font-semibold" data-id="element-914">
                          {daySchedule.privateLessons}
                        </span>
                      </div>
                    </div>
                  </div>

                  {/* Classes */}
                  <div className="p-6" data-id="element-915">
                    {daySchedule.note ? <div className="text-center py-8" data-id="element-916">
                        <Shield className="w-12 h-12 text-[#00D4FF] mx-auto mb-4" data-id="element-917" />
                        <p className="text-xl text-gray-300 font-semibold mb-2" data-id="element-918">
                          Private Lessons Only
                        </p>
                        <p className="text-gray-400" data-id="element-919">{daySchedule.note}</p>
                      </div> : <div className="grid grid-cols-1 lg:grid-cols-2 gap-8" data-id="element-920">
                        {/* Taekwondo */}
                        {daySchedule.taekwondo && <div data-id="element-921">
                            <h3 className="text-xl font-bold text-[#00D4FF] mb-4 flex items-center gap-2" data-id="element-922">
                              <div className="w-2 h-2 bg-[#00D4FF] rounded-full" data-id="element-923" />
                              Taekwondo
                            </h3>
                            <div className="space-y-3" data-id="element-924">
                              {daySchedule.taekwondo.map((cls, idx) => <div key={idx} className="bg-black/50 p-4 rounded-lg border border-gray-800" data-id="element-925">
                                  <div className="flex justify-between items-start mb-2" data-id="element-926">
                                    <span className="font-semibold text-white" data-id="element-927">
                                      {cls.name}
                                    </span>
                                    <span className="text-xs bg-[#00D4FF]/20 text-[#00D4FF] px-2 py-1 rounded-full" data-id="element-928">
                                      {cls.ages}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-2 text-gray-400 text-sm" data-id="element-929">
                                    <Clock className="w-4 h-4" data-id="element-930" />
                                    {cls.time}
                                  </div>
                                </div>)}
                            </div>
                          </div>}

                        {/* Kickboxing */}
                        {daySchedule.kickboxing && <div data-id="element-931">
                            <h3 className="text-xl font-bold text-[#FF6B35] mb-4 flex items-center gap-2" data-id="element-932">
                              <div className="w-2 h-2 bg-[#FF6B35] rounded-full" data-id="element-933" />
                              Kickboxing
                            </h3>
                            <div className="space-y-3" data-id="element-934">
                              {daySchedule.kickboxing.map((cls, idx) => <div key={idx} className="bg-black/50 p-4 rounded-lg border border-gray-800" data-id="element-935">
                                  <div className="flex justify-between items-start mb-2" data-id="element-936">
                                    <span className="font-semibold text-white" data-id="element-937">
                                      {cls.name}
                                    </span>
                                    <span className="text-xs bg-[#FF6B35]/20 text-[#FF6B35] px-2 py-1 rounded-full" data-id="element-938">
                                      {cls.ages}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-2 text-gray-400 text-sm" data-id="element-939">
                                    <Clock className="w-4 h-4" data-id="element-940" />
                                    {cls.time}
                                  </div>
                                </div>)}
                            </div>
                          </div>}

                        {/* Sparring */}
                        {daySchedule.sparring && <div data-id="element-941">
                            <h3 className="text-xl font-bold text-[#00D4FF] mb-4 flex items-center gap-2" data-id="element-942">
                              <div className="w-2 h-2 bg-[#00D4FF] rounded-full" data-id="element-943" />
                              Sparring
                            </h3>
                            <div className="space-y-3" data-id="element-944">
                              {daySchedule.sparring.map((cls, idx) => <div key={idx} className="bg-black/50 p-4 rounded-lg border border-gray-800" data-id="element-945">
                                  <div className="flex justify-between items-start mb-2" data-id="element-946">
                                    <span className="font-semibold text-white" data-id="element-947">
                                      {cls.name}
                                    </span>
                                    <span className="text-xs bg-[#00D4FF]/20 text-[#00D4FF] px-2 py-1 rounded-full" data-id="element-948">
                                      {cls.ages}
                                    </span>
                                  </div>
                                  <div className="flex items-center gap-2 text-gray-400 text-sm" data-id="element-949">
                                    <Clock className="w-4 h-4" data-id="element-950" />
                                    {cls.time}
                                  </div>
                                </div>)}
                            </div>
                          </div>}
                      </div>}
                  </div>
                </motion.div>;
          })}
          </div>
        </div>
      </section>

      {/* Additional Programs */}
      <section className="py-20 bg-black" data-id="element-951">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-952">
          <h2 className="text-3xl font-bold text-white mb-12 text-center" data-id="element-953">
            Additional Programs
          </h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-954">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800" data-id="element-955">
              <Users className="w-12 h-12 text-[#00D4FF] mb-4" data-id="element-956" />
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-957">
                Self Defense Seminars
              </h3>
              <p className="text-gray-400 mb-4" data-id="element-958">
                Specialized self-defense training available for individuals,
                groups, and corporate teams.
              </p>
              <ul className="space-y-2 text-gray-300" data-id="element-959">
                <li className="flex items-center gap-2" data-id="element-960">
                  <div className="w-1.5 h-1.5 bg-[#00D4FF] rounded-full" data-id="element-961" />
                  Individual Sessions
                </li>
                <li className="flex items-center gap-2" data-id="element-962">
                  <div className="w-1.5 h-1.5 bg-[#00D4FF] rounded-full" data-id="element-963" />
                  Group Workshops
                </li>
                <li className="flex items-center gap-2" data-id="element-964">
                  <div className="w-1.5 h-1.5 bg-[#00D4FF] rounded-full" data-id="element-965" />
                  Corporate Training
                </li>
              </ul>
              <a href="/free-trial" className="inline-block mt-6 px-6 py-3 bg-[#00D4FF] text-black font-bold rounded-lg hover:bg-[#33ddff] transition-colors" data-id="element-966">
                Schedule Seminar
              </a>
            </motion.div>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: 0.1
          }} className="bg-[#1a1a1a] p-8 rounded-2xl border border-gray-800" data-id="element-967">
              <Calendar className="w-12 h-12 text-[#00D4FF] mb-4" data-id="element-968" />
              <h3 className="text-2xl font-bold text-white mb-4" data-id="element-969">
                Private Lessons
              </h3>
              <p className="text-gray-400 mb-4" data-id="element-970">
                One-on-one instruction tailored to your specific goals and
                schedule. Perfect for accelerated learning.
              </p>
              <ul className="space-y-2 text-gray-300" data-id="element-971">
                <li className="flex items-center gap-2" data-id="element-972">
                  <div className="w-1.5 h-1.5 bg-[#00D4FF] rounded-full" data-id="element-973" />
                  Personalized Training Plans
                </li>
                <li className="flex items-center gap-2" data-id="element-974">
                  <div className="w-1.5 h-1.5 bg-[#00D4FF] rounded-full" data-id="element-975" />
                  Flexible Scheduling
                </li>
                <li className="flex items-center gap-2" data-id="element-976">
                  <div className="w-1.5 h-1.5 bg-[#00D4FF] rounded-full" data-id="element-977" />
                  All Skill Levels Welcome
                </li>
              </ul>
              <a href="/free-trial" className="inline-block mt-6 px-6 py-3 bg-[#00D4FF] text-black font-bold rounded-lg hover:bg-[#33ddff] transition-colors" data-id="element-978">
                Book Private Lesson
              </a>
            </motion.div>
          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-20 bg-[#0a0a0a]" data-id="element-979">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-980">
          <h2 className="text-3xl font-bold text-white mb-6" data-id="element-981">
            Ready to Get Started?
          </h2>
          <p className="text-xl text-gray-300 mb-8" data-id="element-982">
            Join us for a free trial class and experience the Walker's
            difference.
          </p>
          <a href="/free-trial" className="inline-flex items-center gap-2 px-8 py-4 bg-[#00D4FF] text-black font-bold rounded-full hover:bg-[#33ddff] transition-colors shadow-[0_0_20px_rgba(0,212,255,0.4)]" data-id="element-983">
            Schedule Free Trial
          </a>
        </div>
      </section>

      <Footer data-id="element-984" />
    </div>;
}